import classNames from 'classnames'
import { LoadingSpinner } from '../loading'

function Button ({
  label,
  onClick,
  primary,
  size,
  type = 'button',
  isLoading = false,
  danger = false,
  otherClassName = '',
  form,
  ...otherProps
}) {
  const css = classNames(
    {
      'btn-primary': primary,
      'btn-secondary': !primary && !danger,
      'btn-danger': danger && !primary,
      'btn-sm': size === 'sm'
    },
    otherClassName
  )
  const content = isLoading ? (<LoadingSpinner className='h-3.5' />) : label
  const handleClick = isLoading ? undefined : onClick
  const formName = isLoading ? undefined : form

  return (
    <button
      type={type}
      className={css}
      onClick={handleClick}
      form={formName}
      {...otherProps}
    >
      {content}
    </button>
  )
}

export default Button
